import { RadioProps } from '../../types/RadioProps';
export const Radio = ({
  groupName,
  option,
  value,
  icon,
  onChange,
  checked
}: RadioProps) => {
  return (
    <div className='radio flex flex-col gap-2'>
      <div className='relative flex items-center gap-2'>
        {icon && icon}
        <label>
          {option}
          <input
            type='radio'
            name={groupName}
            value={value}
            className='absolute hidden'
            checked={checked}
            onChange={onChange}
          />
          <span className='absolute top-0 right-0 w-6 h-6 border rounded-full'>
            <span className='relative block rounded-full bg-white w-2 h-2 top-[7px] left-[7px]'></span>
          </span>
        </label>
      </div>
    </div>
  );
};
